import React from 'react';
import { useTranslation } from 'react-i18next';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.buildmyshifts.mobile';
const APP_STORE_URL = 'https://apps.apple.com/us/app/buildmyshifts/id6760178803';
const APP_STORE_BADGE = 'https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg';
const GOOGLE_PLAY_BADGE = 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';

function StoreBadge({ href, src, alt, className = '', imgClassName = 'h-14 w-auto' }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center transition-transform hover:-translate-y-0.5 ${className}`}
      aria-label={alt}
    >
      <img
        src={src}
        alt={alt}
        className={imgClassName}
        loading="lazy"
      />
    </a>
  );
}

export default function AppDownloadLinks({ compact = false, dark = false, className = '' }) {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={compact ? 'space-y-3' : 'space-y-4'}>
        <div>
          <h3 className={`font-semibold ${dark ? 'text-white' : 'text-gray-900'}`}>
            {t('appDownloads.title', 'Get the mobile app')}
          </h3>
          <p className={`mt-1 text-sm ${dark ? 'text-gray-300' : 'text-gray-600'}`}>
            {t('appDownloads.subtitle', 'Open rotas, swaps, and time tracking on the go.')}
          </p>
        </div>

        <div className={`flex ${compact ? 'flex-col' : 'flex-col sm:flex-row'} items-start gap-3`}>
          <StoreBadge
            href={APP_STORE_URL}
            src={APP_STORE_BADGE}
            alt={t('appDownloads.appStoreAlt', 'Download on the App Store')}
          />
          <StoreBadge
            href={GOOGLE_PLAY_URL}
            src={GOOGLE_PLAY_BADGE}
            alt={t('appDownloads.googlePlayAlt', 'Get it on Google Play')}
            className="-ml-4"
            imgClassName="h-[82px] w-auto -my-[14px]"
          />
        </div>
      </div>
    </div>
  );
}
